// src: https://medium.com/@vladkens/automatic-parsing-of-date-strings-in-rest-protocol-with-typescript-cf43554bd157

import { parseISO } from 'date-fns';

const ISODateFormat =
  /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d*)?(?:[-+]\d{2}:?\d{2}|Z)?$/;

const isIsoDateString = (val: unknown): val is string =>
  typeof val === 'string' && val[10] === 'T' && ISODateFormat.test(val);

export const transformStringToDate = (
  data?: Partial<Record<string, unknown>> | string
) => {
  if (isIsoDateString(data)) {
    return parseISO(data);
  }
  if (data === null || data === undefined || typeof data !== 'object') {
    return data;
  }
  for (const [key, val] of Object.entries(data)) {
    if (isIsoDateString(val)) {
      data[key] = parseISO(val);
    } else if (typeof val === 'object') {
      transformStringToDate(val as typeof data);
    }
  }
  return data;
};
